export default {
    name: 'Atlas',
}
